export default {
    name: 'Atlas',
}
